import { PublicClientApplication, EventType, type EventMessage, type AuthenticationResult } from '@azure/msal-browser'
import { msalConfig, isEntraConfigured } from './msalConfig'

// The MSAL instance lives here rather than in AuthProvider.tsx so that file exports
// only its component: a module mixing component and non-component exports defeats
// React Fast Refresh (react-refresh/only-export-components).

const resolvedEntraClientId =
  import.meta.env.VITE_ENTRA_CLIENT_APP_CLIENT_ID ||
  import.meta.env.VITE_ENTRA_CLIENT_ID

// Log Entra ID configuration at startup for diagnostics
console.warn('[Lighthouse.Auth] Client App Entra ID configuration:', {
  clientId: resolvedEntraClientId
    ? `${(resolvedEntraClientId as string).substring(0, 8)}...`
    : '(empty)',
  tenantId: import.meta.env.VITE_ENTRA_TENANT_ID
    ? `${(import.meta.env.VITE_ENTRA_TENANT_ID as string).substring(0, 8)}...`
    : '(empty)',
  apiScope: import.meta.env.VITE_ENTRA_API_CLIENT_ID || '(empty)',
  isEntraConfigured: isEntraConfigured(),
  redirectUri: window.location.origin,
})

// Create MSAL instance (only if configured)
function createMsalInstance(): PublicClientApplication | null {
  if (!isEntraConfigured()) {
    return null
  }

  const instance = new PublicClientApplication(msalConfig)

  // Set up event callbacks for login/logout
  instance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult
      instance.setActiveAccount(payload.account)
    }
  })

  // Note: initialization is awaited in main.tsx before the app renders
  return instance
}

export const msalInstance = createMsalInstance()
